<template>
</template>
<script>
  import http from "../libs/http"

  export default {
    data() {
      return {
        dataPages: {totalElements:0, number: 0},
        dataCurrent: {},
        searchParams: {fuzzy: null},
        searching: false,
        searchApi: null,
      }
    },
    mounted() {
      this.search()
    },
    methods: {
      search(page) {
        if (typeof page !== 'number') {
          page = null
        }
        // 将page设置到地址路径的参数中, 这样刷新的时候能保持页码
        page = page || this.$route.query.page || 1;
        this.$router.push({path: this.$route.path, query: {page: page}});

        // 前端的page是1开始, 后台参数是0开始
        const params = {
          page: page - 1
        }

        let conditions = []
        if (this.searchParams.fuzzy && this.searchParams.fuzzyParams) {
          let condition = {op: 'or', elements: []}
          for (let param of this.searchParams.fuzzyParams) {
            condition.elements.push({op: "contains", param: param, values: this.searchParams.fuzzy})
          }
          conditions.push(condition)
        }

        console.log(typeof this.searchConditions)

        if (typeof this.searchConditions === 'function') {
          conditions = conditions.concat(this.searchConditions())
        }

        if (conditions.length) {
          params.jsonConditions = {op: "and", elements: conditions};
        }

        this.searching = true
        http.get(this.searchApi, {params}).then(payload => this.dataPages = payload).finally(()=>this.searching = false)
      },
      changeCurrent(payload) {
        this.dataCurrent = payload
        let pos = this.dataPages.content.findIndex((item) => {return item.id === payload.id})
        if (pos >= 0) {
          this.dataPages.content.splice(pos, 1, payload)
        }
      },
      deleteIndex(index) {
        this.dataPages.content.deleteIndex(index)
      }
    }
  }
</script>
